<template>
  <div class="custom-selector">
    <b-dropdown
      text="Select"
      class="custom-selector__dropdown w-100"
      :class="[stateClass, { 'custom-selector--disabled': disabled }]"
      :disabled="disabled"
      toggle-class="active-list pr-0"
      no-caret
      @show="handleMenuShow"
      @hide="handleMenuHide"
    >
      <template #button-content>
        <div class="d-flex flex-row justify-content-between pr-3">
          <span>{{ text }}</span>
          <SwitchIcon v-if="!disabled" :is-active="isActive" />
        </div>
      </template>

      <b-dropdown-item-button
        v-for="option in options"
        :key="option.value"
        @click="handleSelection(option.value)"
      >
        {{ option.text }}
      </b-dropdown-item-button>
    </b-dropdown>
  </div>
</template>

<script>
import { find, isEmpty } from 'lodash';
import SwitchIcon from './SwitchIcon';

export default {
  name: 'CustomSelector',
  components: {
    SwitchIcon
  },
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '',
      validate(val) {
        return isEmpty(val);
      }
    },
    state: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  computed: {
    text() {
      if (this.value !== null) {
        return this.$get(find(this.options, ['value', this.value]), 'text');
      }
      return this.placeholder;
    },
    stateClass() {
      if (this.state === true) return 'is-valid';
      if (this.state === false) return 'is-invalid';
      return '';
    }
  },
  methods: {
    handleMenuShow() {
      this.isActive = true;
    },
    handleMenuHide() {
      this.isActive = false;
    },
    handleSelection(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss">
.custom-selector {
  &__dropdown {
    color: $black-color;
    padding: 0;

    .active-list {
      background: $primary-color !important;
    }

    .switch-icon {
      filter: grayscale(1) invert(1);
    }

    .dropdown-toggle {
      background-color: $dark-color;
      color: $black-color !important;
      padding: 15px;
      border: 1px solid $primary-color;
      border-radius: 10px;
    }

    .dropdown-toggle,
    .dropdown-toggle:active {
      outline-style: none;
    }

    .dropdown-toggle:hover {
      outline-style: none;
      background-color: $dark-color;
    }

    ul {
      max-height: 300px;
      overflow-y: scroll;
      width: 100%;
      background-color: $dark-color;
      color: $white-color;
      border-radius: 12px;
      border: 1px solid $white-color;
      z-index: 3;

      &::-webkit-scrollbar-thumb {
        background: $white-color;
        border-radius: 5px;
      }

      &::-webkit-scrollbar {
        background: $dark-color;
        width: 10px;
      }

      li {
        button {
          color: $white-color;
        }
      }
    }

    &.is-valid {
      .dropdown-toggle,
      .dropdown-toggle:active,
      .dropdown-toggle:hover {
        border-color: #28a745 !important;
      }
    }

    &.is-invalid {
      .dropdown-toggle,
      .dropdown-toggle:active,
      .dropdown-toggle:hover {
        border-color: $red-color !important;
      }
    }
  }

  &--disabled {
    .dropdown-toggle {
      cursor: not-allowed;
    }
  }
}
</style>
